/**
 * Format a UTC timestamp string into the user's local time as dd.mm.yyyy hh:mm:ss.
 *
 * Accepts formats like:
 *   - "2026-04-24 13:00:38"
 *   - "2026-04-24 13:00:38.084842+00"
 *   - ISO 8601 strings
 *
 * Returns the formatted string or the original value if parsing fails.
 */
export function formatTimestamp(raw) {
  if (!raw) return '';
  let s = String(raw).trim();

  // Replace first space with 'T' for ISO compatibility
  // "2026-04-24 13:00:38.084842+00" → "2026-04-24T13:00:38.084842+00"
  if (/^\d{4}-\d{2}-\d{2} /.test(s)) {
    s = s.replace(' ', 'T');
  }

  // Strip fractional seconds (.084842) — keep only up to seconds
  s = s.replace(/(\d{2}:\d{2}:\d{2})\.\d+/, '$1');

  // Normalize short timezone offsets: "+00" → "+00:00", "-05" → "-05:00"
  s = s.replace(/([+-])(\d{2})$/, '$1$2:00');

  // If no timezone info at all, assume UTC
  if (!/Z$/.test(s) && !/[+-]\d{2}:\d{2}$/.test(s)) {
    s += 'Z';
  }

  const d = new Date(s);
  if (isNaN(d.getTime())) return String(raw);

  const pad = (n) => String(n).padStart(2, '0');
  return (
    pad(d.getDate()) + '.' +
    pad(d.getMonth() + 1) + '.' +
    d.getFullYear() + ' ' +
    pad(d.getHours()) + ':' +
    pad(d.getMinutes()) + ':' +
    pad(d.getSeconds())
  );
}
